import React, { useState, useContext } from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
// import 'date-fns';
// import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import { StoreContext } from "../../../store/Provider";
import TextField from "@mui/material/TextField";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import "./modal.css";

const parseDateRange = (rangeStr) => {
  if (!rangeStr) return [null, null];
  const [from, to] = rangeStr.split(" - ");
  const fromDate = from ? moment(from, "MM/DD/YYYY").toDate() : null;
  const toDate = to ? moment(to, "MM/DD/YYYY").toDate() : fromDate;
  return [fromDate, toDate];
};

function AddFilter() {
  const context = useContext(StoreContext);
  const appliedFilter = context.advSearchFilter;
  const [initialDateFrom, initialDateTo] = parseDateRange(
    appliedFilter.eta || appliedFilter.etd
  );

  const [modeValue, setModeValue] = useState(appliedFilter.tranportMode || "");
  const [dateTypeValue, setDateTypeValue] = useState(
    appliedFilter.eta ? "ETA" : appliedFilter.etd ? "ETD" : ""
  );
  const [dateFrom, setDateFrom] = useState(initialDateFrom);
  const [dateTo, setDateTo] = useState(initialDateTo);

  const handleChangeDateFrom = (date) => {
    setDateFrom(date);
  };

  const handleChangeDateTo = (date) => {
    setDateTo(date);
  };

  const handleChangemode = (event) => {
    setModeValue(event.target.value);
  };

  const handleChangeDateType = (event) => {
    setDateTypeValue(event.target.value);
  };

  const isDateRangeIncomplete =
    dateTypeValue !== "" && (!dateFrom || !dateTo);

  const isApplyDisabled = isDateRangeIncomplete;

  const validationMessage = isDateRangeIncomplete
    ? `Please select both "From" and "To" dates for ${dateTypeValue}.`
    : "";

  const resetFilters = () => {
    setModeValue("");
    setDateTypeValue("");
    setDateFrom(null);
    setDateTo(null);
  };

  const filterSearch = () => {
    context.setShipmentId("");
    context.setSearchInputValue("");
    context.handleModalClose();

    if (modeValue === "" && dateTypeValue === "") {
      context.setAdvFilterCall(false);
      context.setSearchResultView(false);
      context.setAdvSearchFilter({
        tranportMode: "",
        etd: "",
        eta: "",
      });
      return;
    }

    context.setSearchResultView(true);
    context.setAdvFilterCall(true);
    let firstDate = moment(dateFrom).format("MM/DD/YYYY");
    let lastDate = moment(dateTo).format("MM/DD/YYYY");
    let finaldate = `${firstDate} - ${lastDate}`;
    if (dateTypeValue === "ETA") {
      context.setAdvSearchFilter({
        tranportMode: modeValue,
        eta: finaldate,
        etd: ""
      });
    } else if (dateTypeValue === "ETD") {
      context.setAdvSearchFilter({
        tranportMode: modeValue,
        etd: finaldate,
        eta: ""
      });
    } else {
      context.setAdvSearchFilter({
        tranportMode: modeValue,
        etd: "",
        eta: ""
      });
    }
  };

  return (
    <div className="filterModeComponent searchFilterShipment">
      <div className="modalHeading">
        <h6>Apply Filters</h6>
        <CloseIcon className="pointer" onClick={context.handleModalClose} />
      </div>
      <div className="filterModalBody">
        <RadioGroup
          className="modeFilter"
          name="filterMode"
          value={modeValue}
          onChange={handleChangemode}
        >
          <FormControlLabel
            value="AIR"
            control={<Radio color="primary" />}
            label="Air Only"
          />
          <FormControlLabel
            value="SEA"
            control={<Radio color="primary" />}
            label="Sea Only"
          />
        </RadioGroup>
        <RadioGroup
          className="dateFilter"
          name="dateFilter"
          value={dateTypeValue}
          onChange={handleChangeDateType}
        >
          <FormControlLabel
            value="ETA"
            control={<Radio color="primary" />}
            label="ETA"
          />
          <FormControlLabel
            value="ETD"
            control={<Radio color="primary" />}
            label="ETD"
          />
        </RadioGroup>
        {dateTypeValue === "" ? null : (
          <div className="dateRangeSection">
            <p className="dateRangeTitle">Select {dateTypeValue} Date Range</p>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <div className="dateRangeFields">
                <div className="dateFieldWrap">
                  <span className="dateFieldLabel">From</span>
                  <MobileDatePicker
                    className="etdFilter"
                    maxDate={new Date()}
                    id="etdFilter"
                    inputFormat="MM/dd/yyyy"
                    value={dateFrom}
                    onChange={handleChangeDateFrom}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="filled"
                        size="small"
                        placeholder="MM/DD/YYYY"
                      />
                    )}
                  />
                </div>
                <div className="dateFieldWrap">
                  <span className="dateFieldLabel">To</span>
                  <MobileDatePicker
                    className="etaFilter"
                    minDate={dateFrom}
                    inputFormat="MM/dd/yyyy"
                    value={dateTo}
                    onChange={handleChangeDateTo}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="filled"
                        size="small"
                        placeholder="MM/DD/YYYY"
                      />
                    )}
                  />
                </div>
              </div>
            </LocalizationProvider>
          </div>
        )}
      </div>
      {validationMessage ? (
        <p className="filterValidationMessage">{validationMessage}</p>
      ) : null}
      <div className="modalFooter mt-3">
        <Button variant="contained" onClick={resetFilters}>
          Reset
        </Button>
        <Button
          variant="contained"
          onClick={filterSearch}
          disabled={isApplyDisabled}
        >
          Apply
        </Button>
      </div>
    </div>
  );
}

export default AddFilter;
